"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const types_1 = require("../types");
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const SizeTypes = types_1.tuple('small', 'big');
class TextInput extends react_1.Component {
    render() {
        const _a = this.props, { id, name, label, invalid, big, type, disabled, sideText, autoComplete, forwardedRef, errorMessage, successMessage, placeholder, isError, isSuccess, boxClassName, inputClassName, onClickText } = _a, restProps = __rest(_a, ["id", "name", "label", "invalid", "big", "type", "disabled", "sideText", "autoComplete", "forwardedRef", "errorMessage", "successMessage", "placeholder", "isError", "isSuccess", "boxClassName", "inputClassName", "onClickText"]);
        const textInputBaseClassName = 'input-box';
        const textInputBigClassName = big ? 'big' : '';
        const textInputClassName = classnames_1.default(textInputBaseClassName, textInputBigClassName, boxClassName);
        const inputInvalidClassName = invalid ? 'invalid' : 'valid';
        const inputIsErrorClassName = isError ? 'is-error' : '';
        const inputIsSuccessClassName = isSuccess ? 'is-success' : '';
        const inputFinalClassName = classnames_1.default(inputInvalidClassName, inputIsErrorClassName, inputIsSuccessClassName, inputClassName);
        const shouldDisplayError = isError && errorMessage;
        const shouldDisplaySuccess = isSuccess && successMessage;
        return (react_1.default.createElement("div", { className: textInputClassName },
            react_1.default.createElement("input", Object.assign({ ref: forwardedRef, type: type, id: id, name: name, placeholder: placeholder, className: inputFinalClassName, disabled: disabled, "aria-label": label, "aria-labelledby": `${id}-label`, "aria-controls": id, "aria-describedby": `${id}-label`, "aria-autocomplete": autoComplete ? 'inline' : 'none' }, restProps)),
            react_1.default.createElement("label", { htmlFor: id, id: `${id}-label` }, label),
            this.props.icon && this.props.icon,
            sideText && react_1.default.createElement("button", { onClick: onClickText }, sideText),
            shouldDisplayError && errorMessage && (react_1.default.createElement("span", { className: 'input-message error' }, errorMessage)),
            shouldDisplaySuccess && successMessage && (react_1.default.createElement("span", { className: 'input-message success' }, successMessage))));
    }
}
exports.TextInput = TextInput;
TextInput.defaultProps = {
    type: 'text',
    required: false,
    placeholder: ' '
};
exports.default = ForwardRefHOC_1.default(TextInput);
